import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";

export interface RekapBulananIgdPeriode {
  tahun: number;
  bulan: number;
  label: string;
}

export interface RekapBulananIgdMeta {
  total_kunjungan: number;
  tanpa_kasus: number;
}

export interface RekapBulananIgdResponse {
  periode: RekapBulananIgdPeriode;
  rme: Record<string, number>;
  koreksi: Record<string, number>;
  nilai: Record<string, number>;
  meta: RekapBulananIgdMeta;
}

export interface PeriodeParam {
  tahun: number;
  bulan: number;
}

export function keyKasus(seksi: string, kasus: string): string {
  return `bulanan.${seksi}.${kasus}`;
}

export function keyCaraBayar(bayar: string, tindakLanjut: string): string {
  return `bulanan.cara_bayar.${bayar}.${tindakLanjut}`;
}

export function keyTempatPenuh(bayar: string): string {
  return `bulanan.rujuk_tempat_penuh.${bayar}`;
}

export const KEY_DARI_RS = "bulanan.rujukan_dari_bawah.dari_rs";
export const KEY_DARI_PUSKESMAS = "bulanan.rujukan_dari_bawah.dari_puskesmas";
export const KEY_DARI_BP_RB = "bulanan.rujukan_dari_bawah.dari_bp_rb";
export const KEY_DARI_DOKTER_BIDAN =
  "bulanan.rujukan_dari_bawah.dari_dokter_bidan";
export const KEY_DIRUJUK = "bulanan.rujuk_tempat_penuh.dirujuk";
export const KEY_MATI = "bulanan.rujuk_tempat_penuh.mati";

async function get(p: PeriodeParam): Promise<RekapBulananIgdResponse> {
  const res = await http
    .getDataParam(`/laporan/rekap-bulanan-igd`, { params: p })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return res.data.data;
}

async function save(
  p: PeriodeParam,
  koreksi: Record<string, number>
): Promise<RekapBulananIgdResponse> {
  const res = await http
    .putData(`/laporan/rekap-bulanan-igd`, { ...p, koreksi })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return res.data.data;
}

async function openPdf(p: PeriodeParam): Promise<void> {
  const res = await http
    .getDataParam(`/laporan/rekap-bulanan-igd/pdf`, {
      params: p,
      responseType: "blob"
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  const url = URL.createObjectURL(
    new Blob([res.data], { type: "application/pdf" })
  );
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default { get, save, openPdf };
